import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ContractorsDataSource } from '../types'

const getOptions = (): Array<Column<ContractorsDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap) as Array<keyof ContractorsDataSource>

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
  })
}

export const getColumns = (): Array<Column<ContractorsDataSource>> => {
  return getColumnsFromMap<ContractorsDataSource>({
    columnTitleMap,
    options: getOptions()
  })
}
